enum DynamicPassiveIncomeModifierId {
    PILGRIM = 'PILGRIM'
}

export default DynamicPassiveIncomeModifierId;